import React from "react";
import Menu from "../../components/menu/Menu";

function Item2() {
  return (
    <>
      <Menu />
      <main>
        <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
          <div className="container">
            <h1 className="text-center h4">Item 2</h1>
          </div>
        </section>
      </main>
    </>
  );
}

export default Item2;
